import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';

import Yes from 'Images/yes.svg';
import No from 'Images/no.svg';

const style = {
  whiteSpace: 'pre',
};
const fixDesc = (criteria, criterias) => {
  let id = criteria;
  const { name, value, unit } = criterias;
  if (name && !value) {
    return `${name} `;
  }
  if (name && value) {
    if (
      id === 132 ||
      id === 389 ||
      id === 270 ||
      id === 318 ||
      id === 319 ||
      id === 320 ||
      id === 321 ||
      id === 322 ||
      id === 323 ||
      id === 324 ||
      id === 325 ||
      id === 391 ||
      id === 330 ||
      id === 1304 ||
      id === 261
    ) {
      if (unit === null) {
        return `${value}`;
      } else {
        return `${value}${unit !== null ? ' ' + unit : ''} `;
      }
    } else {
      if (id === 326 || id === 327 || id === 329) {
        return `${name.charAt(0) === ' ' ? name.slice(1) : name} ${value}${
          unit !== null ? ' ' + unit : ''
        },`;
      } else if (id === 63 || id === 111 || id === 328 || id === 65) {
        return `${name.charAt(0) === ' ' ? name.slice(1) : name} ${value}${
          unit !== null ? ' ' + unit : ''
        }`;
      } else if (id === 261) {
        return `${name}: ${value}${unit !== null ? ' ' + unit : ''}`;
      } else if (id === 376 || id === 331) {
        return `${value}${unit !== null ? ' ' + unit : ''}`;
      }
      return `${name}: ${value}${unit !== null ? ' ' + unit : ''}, `;
    }
  }
  return '';
};

export const CheckListCriteria = props => {
  return (
    <Grid
      item
      // lg={4}
      md={6}
      xs={12}
      className="checklist-criteria-element-wrapper"
    >
      <Grid
        container
        spacing={0}
        className="checklist-criteria-element u-pad-8"
      >
        <Grid
          item
          // lg={4}
          // md={6}
          xs={3}
        >
          <div className="t-primary-12 t-weight-b ">
            {props.currentCriteria.name}:
          </div>
        </Grid>
        <Grid
          item
          // lg={4}
          // md={6}
          xs={8}
          className="criteria-values-isChecked"
        >
          {props.currentCriteria.criteria
            ? props.currentCriteria.criteria.map(key1 => {
                return (
                  <div
                    className="t-primary-14 c-gray-light criteria-description"
                    key={key1}
                  >
                    <span style={style}>
                      {fixDesc(key1, props.criteria[key1])}
                    </span>
                  </div>
                );
              })
            : null}
        </Grid>
        {props.currentCriteria.criteria ? (
          props.currentCriteria.criteria
            .map(key1 => props.criteria[key1].checked)
            .includes(true) ? (
            <Grid
              item
              // lg={4}
              // md={6}
              xs={1}
            >
              <img src={Yes} />
            </Grid>
          ) : (
            <Grid
              item
              // lg={4}
              // md={6}
              xs={1}
            >
              <img src={No} />
            </Grid>
          )
        ) : null}
      </Grid>
    </Grid>
  );
};
